/* eslint-disable no-unused-vars */
import { $http, http } from '@/utils/http'
import host from '@/utils/host'

export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async getCMSConfig({ commit }, { buzzType = 'pop', key }) {
      const data = await http.get(`${host.cms}/publish/976/platform-template.json`)
      if (data) {
        return data[buzzType][key]
      }
      return {}
    }
  },
  getters: {

  }
}
